<template>
	<div class="StaticGmaps">
		<img :src="value" alt=" ">
		<div class="row">
			<div class="col-xs-12 col-sm-4">
				<input name="isauto" type="checkbox" v-model="isAuto">
			</div>
			<div class="col-xs-12 col-sm-8">
				<label for="isAuto">Automatisch Ausrichten</label>
			</div>
		</div>
		<div class="row" v-if="!isAuto">
			<div class="col-xs-12 col-sm-4">
				<input type="text" v-model="helper_center">
			</div>
			<div class="col-xs-12 col-sm-8">
				<label for="isAuto">Mittlepunkt</label>
			</div>

			<div class="col-xs-12 col-sm-4">
				<input :disabled="!helper_center" v-model="zoom" type="range" min="0" max="20" step="0.5">
			</div>
			<div class="col-xs-12 col-sm-8">
				<label for="isAuto">Zoom</label>
			</div>
		</div>
		<input type="button" value="update" @click="getStaticMapsUrl()">
	</div>
</template>

<script>
import forEach from 'lodash/forEach';
import debounce from 'lodash/debounce';

/**

{
	icon: 'https://cdn3.iconfinder.com/data/icons/forum-emoticons-2-20x20/20/Bier.png',
	address: 'Hannover Abelmanstraße 27 Germany',
	title: 'Hannover <3'
},
{
	icon: 'https://cdn3.iconfinder.com/data/icons/forum-emoticons-2-20x20/20/Bier.png',
	address: 'Hannover Bernwardstraße 38 Germany',
	title: 'Hannover <3'
},
{
	icon: 'https://cdn3.iconfinder.com/data/icons/forum-emoticons-2-20x20/20/Bier.png',
	address: 'Hannover Königstraße 49 Germany',
	title: 'Hannover <3'
}

 */

export default {
	name: 'StaticGmaps',
	computed: {
		helper_center: {
			get () {
				if(this.center.length > 0) return this.center;
		      	return '';
		    },
		    set (value) {
		    	if(value.length >0) this.center = value;
		    	else this.center = false;
		    }
		}
	},
	data() {
		return {
			value: '',
			isAuto: true,


			zoom: this.defaultZoom,
			scale: this.defaultScale,
			width: this.defaultWidth,
			height: this.defaultHeight,
			maptype: this.defaultMaptype ,
			format: this.defaultFormat,
			center: this.defaultCenter,
			markerShadow: this.defaultMarkerShadow
		};
	},
	mounted(){
		this.getStaticMapsUrl();
	},
	props: {
		baseUrl: {
			type: String,
			default: 'https://maps.googleapis.com/maps/api/staticmap'
		},
		gkey: {
			type: String,
			default: 'AIzaSyDoz2z-SdUmSpTT4unTyW440q4cR8g7HVM'
		},
		// &zoom=1
		defaultZoom: {
			type: Number,
			default: 12
		},
		// &scale=1
		defaultScale: {
			type: Number,
			default: 1
		},
		// &size=600x300
		defaultWidth: {
			type: Number,
			default: 600
		},
		defaultHeight: {
			type: Number,
			default: 600
		},
		// &maptype=roadmap
		defaultMaptype: {
			type: String,
			default: 'roadmap'
		},
		// &format=png
		defaultFormat: {
			type: String,
			default: 'png'
		},
		defaultCenter: {
			default: false
		},
		defaultMarkerShadow: {
			type: Boolean,
			default: false
		},
		markers: {
			type: Array,
    		default: () => []
		}
	},
	methods: {
		getStaticMapsUrl(){
			var props = {};
			props.key = this.gkey;
			if(this.center){
				props.center = this.center;
				props.zoom = this.zoom;
			} else {
				props.autoscale = 1;
			}
			props.scale = this.scale;
			props.size = this.width + 'x' + this.height;
			props.maptype = this.maptype;
			props.format = this.format;
			props.markers = [];
			// &markers=icon:https://cdn3.iconfinder.com/data/icons/forum-emoticons-2-20x20/20/Bier.png%7Cshadow:true%7CHannover
			forEach(this.markers, (marker, index) => {
				var str = '';
				if(marker.icon) str+= 'icon:' + marker.icon;
				if(this.markerShadow) str += (str.length > 0 ? '|' : '') + 'shadow:true';
				if(marker.address) str += (str.length > 0 ? '|' : '') + marker.address;
				props.markers.push(str);
			});


			var urlParams = "";
			for (var key in props) {
				urlParams += urlParams.length <= 0 ? '?': '&';
				if(typeof props[key] == 'object') {
					forEach(props[key], (value) => {
						urlParams += urlParams.length <= 0 ? '?': '&';
						urlParams += key + "=" + encodeURIComponent(value);
					});
				} else {
					urlParams += key + "=" + encodeURIComponent(props[key]);
				}
			}
			var self = this;
			self.value = this.baseUrl + urlParams;
			self.$emit('input', this.value);
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StaticGmaps.vue